import { render } from "./TreatmentDetail.vue?vue&type=template&id=6dc45d1f"
import script from "./TreatmentDetail.vue?vue&type=script&lang=js"
export * from "./TreatmentDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nice-life-contract/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__